export default {
    menu: {
        courses: 'Kurse',
        courseCategories: 'Kurskategorien',
    },

    menuTooltips: {
        courseGroup: 'alles zu Kursen und was dazugehört (Kurse, Buchungen, Prüfungen, u.v.m.)',
        course_timespans: 'Kurse anlegen, verwalten, deren Teilnehmer einsehen und Teilnehmerlisten ausdrucken',
        courses: 'Kurskategorien erstellen und verwalten. Kurse können einer oder mehreren Kategorien zugeordnet sein, z.B. SBF-Binnen und Abendkurs oder SKS und Wochenendkurs',
    }
}